import { createComponent } from '../lib';
import { VmSettingsControl, VmControl, VmIcon, VmTooltip } from '@vime/core';
import { define } from '../lib';
define('vm-settings-control', VmSettingsControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
;
export default createComponent('vm-settings-control', new Set(['icon', 'icons', 'tooltipPosition', 'tooltipDirection', 'menu', 'expanded', 'i18n', 'hideTooltip']));
